import { render, staticRenderFns } from "./ResultSharingAdd.vue?vue&type=template&id=5fd634ca"
import script from "./ResultSharingAdd.vue?vue&type=script&lang=js"
export * from "./ResultSharingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports